import React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { BodySmallBoldSmallStyles, BodySmallBoldLargeStyles } from 'web-ui-kit/typography';
import UnsegmentedControlWithBackgroundColor from 'web-ui-kit/SelectionControls/UnsegmentedControlWithBackgroundColor';
import UnsegmentedControlWithImageOnly from 'web-ui-kit/SelectionControls/UnsegmentedControlWithImageOnly';
import UnsegmentedControl from 'web-ui-kit/SelectionControls/UnsegmentedControl';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function VariantsWithAttributes(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt;
  var variants = productDetailsState.variants,
      variantsLoading = productDetailsState.variantsLoading,
      variantsState = productDetailsState.variantsState; // Early exit if there is nothing to render.

  if (variantsLoading || !variants || !variantsState || !variantsState.options || variantsState.options.length === 0) {
    return null;
  }

  var handleVariantClick = function handleVariantClick(_ref2) {
    var index = _ref2.index,
        optionId = _ref2.optionId,
        option = _ref2.option;
    return function (event) {
      dispatch({
        type: 'product-variant-attribute-click',
        payload: {
          index: index,
          optionId: optionId,
          option: option
        }
      });
    };
  };

  var Container = styles.Container;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "variants"
    }, renderVariants({
      handleVariantClick: handleVariantClick,
      variantsState: variantsState
    }), renderAdditionalOptions({
      variantsState: variantsState,
      handleVariantClick: handleVariantClick
    }))
  );
}

function renderVariants(_ref3) {
  var handleVariantClick = _ref3.handleVariantClick,
      variantsState = _ref3.variantsState;

  var _ref4 = variantsState || {},
      _ref4$options = _ref4.options,
      options = _ref4$options === void 0 ? [] : _ref4$options,
      _ref4$products = _ref4.products,
      products = _ref4$products === void 0 ? {} : _ref4$products,
      selectedIds = _ref4.selectedIds;

  return options.map(function (option) {
    // Special case color
    if (option.type === 'color') {
      return renderColors({
        colorVariants: option,
        handleVariantClick: handleVariantClick,
        products: products,
        selectedIds: selectedIds
      });
    }

    return renderVariantOptions({
      variantOption: option,
      handleVariantClick: handleVariantClick,
      products: products,
      selectedIds: selectedIds
    });
  });
}
/**
 * Helpers
 */


function renderColors(_ref5) {
  var _selectedOption$label;

  var colorVariants = _ref5.colorVariants,
      handleVariantClick = _ref5.handleVariantClick,
      products = _ref5.products,
      selectedIds = _ref5.selectedIds;

  var _ref6 = colorVariants || {},
      index = _ref6.index,
      options = _ref6.options; // We do not want to render single colors.


  if (!options || options.length <= 1) {
    return null;
  }

  var ColorControl = styles.ColorControl,
      ColorThumbsContainer = styles.ColorThumbsContainer,
      ColorThumbsGrid = styles.ColorThumbsGrid,
      Heading = styles.Heading;
  var selectedOption = options.find(function (option) {
    return option.optionId === selectedIds[index];
  });
  return (
    /*#__PURE__*/
    React.createElement(ColorThumbsContainer, null,
    /*#__PURE__*/
    React.createElement(Heading, null, "Color: ".concat((_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : '')),
    /*#__PURE__*/
    React.createElement(ColorThumbsGrid, null, options.map(function (colorOption) {
      var displayType = colorOption.displayType,
          optionId = colorOption.optionId,
          label = colorOption.label,
          value = colorOption.value;
      var selected = optionId === selectedIds[index];

      var potentialKey = _toConsumableArray(selectedIds);

      potentialKey.splice(index, 1, colorOption.optionId);
      potentialKey = potentialKey.join('-');
      var relatedProducts = products[potentialKey];
      var disabled = !relatedProducts || relatedProducts.filter(function (p) {
        return p.availabilityV2.status !== 'OUT_OF_STOCK';
      }).length < 1;
      var status = 'unselected';

      if (selected && disabled) {
        status = 'selected-disabled';
      } else if (selected) {
        status = 'selected';
      } else if (disabled) {
        status = 'disabled';
      }

      return displayType === 'image' || displayType === 'text' ?
      /*#__PURE__*/
      React.createElement(UnsegmentedControlWithImageOnly, {
        key: optionId,
        aspectRatio: 1,
        dispatch: handleVariantClick({
          index: index,
          optionId: optionId,
          option: 0
        }),
        id: "color-".concat(optionId),
        imgixProps: {
          alt: displayType === 'image' ? label : value,
          bucketName: 'modsy',
          fit: 'crop',
          height: 128,
          src: displayType === 'image' ? value : '',
          width: 128
        },
        name: label,
        status: selected ? 'selected' : 'unselected'
      }) : displayType === 'hex' ?
      /*#__PURE__*/
      React.createElement(ColorControl, {
        key: optionId,
        dispatch: handleVariantClick({
          index: index,
          optionId: optionId,
          option: 0
        }),
        id: "color-".concat(optionId),
        color: "#".concat(value),
        status: status,
        name: label
      }) : null;
    })))
  );
}

function renderVariantOptions(_ref7) {
  var variantOption = _ref7.variantOption,
      handleVariantClick = _ref7.handleVariantClick,
      products = _ref7.products,
      selectedIds = _ref7.selectedIds;
  var _variantOption$option = variantOption.options,
      options = _variantOption$option === void 0 ? [] : _variantOption$option,
      index = variantOption.index,
      type = variantOption.type; // We do not want to render single options.

  if (!options || options.length <= 1) {
    return null;
  }

  var selectedOption = options.find(function (option) {
    return option.optionId === selectedIds[index];
  });
  var DimsContainer = styles.DimsContainer,
      DimsGrid = styles.DimsGrid,
      Heading = styles.Heading;
  var displayLabel = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === 'Unknown' ? 'Other' : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || 'Other';
  return (
    /*#__PURE__*/
    React.createElement(DimsContainer, null,
    /*#__PURE__*/
    React.createElement(Heading, null, "".concat(type, ": ").concat(displayLabel)),
    /*#__PURE__*/
    React.createElement(DimsGrid, null, options.map(function (option) {
      var potentialKey = _toConsumableArray(selectedIds);

      potentialKey.splice(index, 1, option.optionId);
      potentialKey = potentialKey.join('-');
      var disabled = !products[potentialKey] || products[potentialKey].length < 1;
      var selected = option.optionId === selectedIds[index]; // We don't want to surface variant options with null values
      // These are going to be logged on the BE and fixed moving forward

      if (option && option.value === 'Unknown') {
        return null;
      }

      return option &&
      /*#__PURE__*/
      React.createElement(UnsegmentedControl, {
        key: option.optionId,
        disabled: disabled,
        dispatch: handleVariantClick({
          index: index,
          optionId: option.optionId,
          option: 0
        }),
        height: "2.5rem",
        id: "pd-dims",
        labelText: option.value || 'Other',
        selected: selected
      });
    })))
  );
}

function renderAdditionalOptions(_ref8) {
  var variantsState = _ref8.variantsState,
      handleVariantClick = _ref8.handleVariantClick;
  var ColorThumbsGrid = styles.ColorThumbsGrid,
      DimsContainer = styles.DimsContainer,
      Heading = styles.Heading;
  var products = variantsState.products,
      selectedKey = variantsState.selectedKey,
      selectedIds = variantsState.selectedIds,
      selectedOption = variantsState.selectedOption;
  var variantProducts = get(products, "".concat(selectedKey));

  if (!variantProducts || variantProducts.length < 2) {
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement(DimsContainer, null,
    /*#__PURE__*/
    React.createElement(Heading, null, "Additional Options"),
    /*#__PURE__*/
    React.createElement(ColorThumbsGrid, null, variantProducts.map(function (product, index) {
      var heroImg = product.heroImg,
          id = product.id,
          name = product.name;
      return (
        /*#__PURE__*/
        React.createElement(UnsegmentedControlWithImageOnly, {
          key: "thumb-".concat(id),
          aspectRatio: 1,
          dispatch: handleVariantClick({
            index: 0,
            optionId: selectedIds[0],
            option: index
          }),
          id: "option-thumb-".concat(id),
          imgixProps: {
            alt: name,
            bucketName: 'modsy',
            fit: 'crop',
            height: 128,
            src: heroImg,
            width: 128
          },
          name: name,
          status: index === selectedOption ? 'selected' : 'unselected'
        })
      );
    })))
  );
}
/**
 * Styles
 */


var styles = {
  AdditionalOptionsList: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  AdditonalOptionsRow: styled(UnsegmentedControl)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: 0.5rem;\n    width: 100%;\n  "]))),
  Container: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1rem 1rem 0 1rem;\n\n    ", " {\n      padding: 1.5rem 0 0 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  ColorControl: styled(UnsegmentedControlWithBackgroundColor)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 2.375rem;\n    height: 2.375rem;\n    padding-bottom: 0;\n  "]))),
  ColorThumbsContainer: styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  ColorThumbsGrid: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    grid-gap: 0.5rem;\n    margin-bottom: 1.5rem;\n\n    ", " {\n      grid-template-columns: repeat(8, 1fr);\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Heading: styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.5rem;\n    text-transform: capitalize;\n\n    ", " {\n      ", ";\n      margin-bottom: 0.5rem;\n    }\n  "])), BodySmallBoldSmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodySmallBoldLargeStyles),
  DimsContainer: styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1.5rem;\n  "]))),
  DimsGrid: styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 0.5rem;\n    grid-row-gap: 0.5rem;\n\n    ", " {\n      grid-template-columns: 1fr 1fr 1fr;\n        grid-column-gap: 0.75rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP)
};
export default VariantsWithAttributes;